<div class="deleteitem-dialog">
  <div class="deleteitem-header">
    <div class="hd-icon hd-icon-delete"></div>
    <div class="deleteitem-header-text">
      {{ 'xs_delete_label' | xsI18n }}
    </div>
    <div class="xs-dialog-close-btn" [soti-tooltip]="'lv-close' | xsI18n" placement="top"
    (click)="onCancel()"></div>
  </div>
  <div class="dialog-header-separator"></div>
  <div class="deleteitem-body">
    <div class="deleteitem-description">{{ getDescriptionMessage() }}</div>

    <div class="file-name-full" sa-ellipsis [fullText]="getFolderName()"></div>

    <div class="error-label" ng-show="getErrorMessage()">{{ getErrorMessage() }}</div>
  </div>

  <div class="buttons-container">
    <button class="xs-btn btn-outline btn-space" (click)="onCancel()">{{ 'xs_cancel_label_short' | xsI18n }}</button>
    <button class="xs-btn btn-primary" (click)="onDelete()">{{ 'xs_delete_label' | xsI18n }}</button>
  </div>
</div>
